import { HCO_CUBE_NAME } from '@/api/hco/constants';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { HCO_TYPE_FILTER_LIMIT } from '../../filterDefaultLimits';

const HCO_TYPE_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.hco_type`],
  limit: HCO_TYPE_FILTER_LIMIT,
});

const hcoTypeFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.hcoTypeLabel',
  placeholder: 'global.filters.formControls.hcoTypePlaceholder',
  type: 'multiselect',
  defaultValue: [],
  searchable: true,
  clearable: true,
  applyDynamicFilters: true,
  sourceCube: HCO_CUBE_NAME,
  getOptionsQuery: HCO_TYPE_OPTIONS,
  mapResult: mapDimensionToOption(`${HCO_CUBE_NAME}.hco_type`),
  applyFilter: value => {
    const selected = Array.isArray(value) ? value.map(String) : [];
    if (selected.length === 0) return undefined;
    return {
      member: `${HCO_CUBE_NAME}.hco_type`,
      operator: 'equals',
      values: selected,
    };
  },
};

export default hcoTypeFilter;
